var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-10 0 1034 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 0 960)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M512 867h-2h-2q-63 0 -118 -24t-96 -65t-65 -96t-24 -117q0 -3 0.5 -5t0.5 -4v0q0 -83 43.5 -173t96.5 -165.5t98.5 -126t50.5 -55.5q3 -3 7.5 -5t9.5 -2q6 0 10.5 2t7.5 5v0q4 5 50 55.5t99 126t96.5 165.5t43.5 173v4v5q0 62 -23.5 117t-64.5 96t-96 65t-118 24h-2.5 h-2.5v0v0zM512 90q-22 24 -65 76t-86 117t-74.5 137t-31.5 136v4v5q0 52 20 98.5t54.5 81t80.5 54.5t99 20h2h2h-1h2h2q52 0 98.5 -20t81 -54.5t54.5 -81t20 -98.5v-5v-4v0q0 -64 -32 -136t-74.5 -137t-85.5 -116.5t-66 -76.5zM512 697q-57 0 -97 -40t-40 -97t40 -97t97 -40 t97.5 40t40.5 97v0.5v0.5v0q-1 56 -41 96t-97 40v0v0v0zM512 472q-36 0 -62 26t-26 62t26 62t62 26q37 0 62.5 -25.5t25.5 -61.5v0q0 -37 -25.5 -62.5t-62.5 -25.5v0v-1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.22fb2b6e.svg";
export { ForwardRef as ReactComponent };